import React from 'react';
import { ThermostatsActions } from '../../../store/actionCreators';
import { Query } from 'react-apollo';
import { GET_DEVICES } from '../../../lib/graphQL/thermostats/queries';
import DeviceItem from '../components/DeviceItem/DeviceItem';
import DeviceList from '../components/DeviceList/DeviceList';

const DeviceQueryContainer = ({ isEcobee }) => {
  return (
    <Query query={GET_DEVICES} variables={{ name: isEcobee ? 'ecobeehome' : 'sensi' }}>
      {({ loading, error, data }) => {
        if (loading) {
          ThermostatsActions.setLoading();
          return null;
        }

        if (error) {
          ThermostatsActions.unsetLoading();
          console.log(`Error...${error}`);
          return null;
        }

        const deviceList = data.serviceProvider.devices.map(device => {
          return <DeviceItem key={device.deviceId} deviceId={device.deviceId} deviceName={device.deviceName} isEcobee={isEcobee} />;
        });

        ThermostatsActions.unsetLoading();

        return <DeviceList>{deviceList}</DeviceList>;
      }}
    </Query>
  );
};

export default DeviceQueryContainer;



// WEBPACK FOOTER //
// ./src/app/thermostats/containers/DeviceQueryContainer.js